<template>
  <b-modal
    centered
    header-bg-variant="primary"
    header-class="text-uppercase"
    header-text-variant="white"
    hide-header-close
    size="lg"
    title="Informacion de Pago"
    ok-only
    footer-border-variant="transparent"
    v-bind="$attrs"
    v-on="$listeners">

    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="onOk">Finalizar</b-button>
    </template>

    <b-form>
      <b-form-row>
        <b-col>
          <p class="title">Información</p>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-5">
        <b-col>
          <b-form-group label="Nombre">
            <b-form-input :value="payment_detail_simplified.first_name" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Apellido">
            <b-form-input :value="payment_detail_simplified.last_name" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <template v-slot:label>N&ordm; de documento</template>
            <b-form-input :value="payment_detail_simplified.identification_number" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <template v-slot:label>N&ordm; de control</template>
            <b-form-input :value="payment_detail_simplified.control_number" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Fecha de Pago">
            <b-form-input v-if="payment_detail_simplified.payment_date" :value="payment_detail_simplified.payment_date | formatDateTime" class="px-0" plaintext/>
            <b-form-input v-else value="Sin pagar" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-5">
        <b-col>
          <b-form-group label="ID Transacción">
            <b-form-input :value="payment_detail_simplified.payment_code" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <template v-slot:label>Tipo</template>
            <b-form-input :value="payment_detail_simplified.type" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Origen">
            <b-form-input :value="payment_detail_simplified.source" class="px-0" plaintext/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Estatus">
            <circle-status v-if="payment_detail_simplified && payment_detail_simplified.status" type='payment' :status="payment_detail_simplified.status"/>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-5">
        <b-col>
          <p class="title">Listado de Pagos</p>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="12" lg="7">
          <b-list-group class="mt-3 details" flush>
            <b-list-group-item class="title">
              <span>Descripción</span>
              <span>Monto</span>
            </b-list-group-item>
            <b-list-group-item
              :key="index"
              class="d-flex flex-row justify-content-between align-items-center" v-for="(detail, index) in paymentDetails.elements">
              <span>{{ detail.description }}</span>
              <span class="d-inline-block text-right">{{ detail.amount }}</span>
            </b-list-group-item>
            <b-list-group-item class="font-weight-bold d-flex flex-row justify-content-between align-items-center">
              <span>Total:</span>
              <span>{{ paymentDetails.total_amount }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
  import { OPEN_LOADER, CLOSE_LOADER } from '@/store/modules/ui/types';
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import CircleStatus from "@/components/CircleStatus";
  export default {
    name: "PaymentDetails",
    props: ['id'],
    components: { CircleStatus },
    data() {
      return {
        paymentDetails: {
          elements: [],
          total_amount: null
        }
      }
    },
    computed: {
      ...mapState('payments', ['payment_detail', 'procedures_pagination']),
      ...mapGetters({payment_detail_simplified: 'payments/payment_detail_simplified'})
    },
    methods: {
      ...mapMutations('ui', [OPEN_LOADER, CLOSE_LOADER]),
      ...mapActions('payments', ['doGetPaymentDetail']),
      onOk() {
        // Se hace algo con el pago
        this.$emit('hide');
      },
      getPaymentDetail() {
        let $vm = this;
        $vm.$store.commit('ui/' + OPEN_LOADER); 
        $vm.doGetPaymentDetail(this.id).finally(() => {
          
          this.paymentDetails.total_amount = this.payment_detail_simplified.total_amount;
          if (this.payment_detail_simplified.type === 'DELIVERY'){
            let newPayment = {
                                description: 'Envío',
                                amount: this.paymentDetails.total_amount,
                              }
            this.paymentDetails.elements.push(newPayment);  
          } else if (this.payment_detail_simplified.type === 'DUPLICADO' || this.payment_detail_simplified.type === 'RENOVACIÓN'){
            let newPayment = {
                                description: 'Servicio de ' + this.payment_detail_simplified.type.charAt(0).toUpperCase() + this.payment_detail_simplified.type.slice(1) + ' de licencia',
                                amount: this.paymentDetails.total_amount,
                              }
            this.paymentDetails.elements.push(newPayment);  
          } else if (this.payment_detail_simplified.type === 'BOLETA'){
            for(let i = 0; i < this.payment_detail_simplified.boletas.length; i++){
              const boleta = this.payment_detail_simplified.boletas[i];
              let newPayment = {
                                description: "Boleta número " + boleta.inf_nro_boleta + " con fecha " + boleta.inf_fecha_boleta,
                                amount: boleta.inf_monto_total,
                              }
              this.paymentDetails.elements.push(newPayment);  
            }
          }
          $vm.$store.commit('ui/' + CLOSE_LOADER); 
        });
      }
    },
    created() {
      this.getPaymentDetail();
    }
  }
</script>

<style lang="scss" scoped>
  p.title {
    font-size: 1.25rem;
  }

  .details {
    font-size: .875rem;

    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border: 1px solid $textgray;
      background: #EFEFEF;
      color: $textgray;
      font-weight: bold;
      border-radius: 4px !important;
    }
  }

  .modal-footer {
    .btn {
      padding: .875rem 3rem;
    }
  }
</style>
